import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormGroup, Label} from "reactstrap";
import {FormattedMessage} from "react-intl";
import Switch from "components/Switch";
import _ from "lodash";

class TabBasket extends PureComponent {

  constructor(props, context) {
    super(props, context);

    this.onChange = this.onChange.bind(this);
  }

  onChange(key, value) {
    let data = this.props.data.survey.questionSettings.basket;

    if(_.isEmpty(data)){
      data = {};
    }

    data[key] = value;

    this.props.onChangeQuestionSettings('basket', data);
  }

  render() {
    const {errors, data} = this.props;

    return (
      <React.Fragment>
        <FormGroup>
          <Label for="rotateAnswers"><FormattedMessage id="_.question.basket.rotateAnswers" /></Label>
          <Switch stickToProp checked={data.survey.questionSettings.basket.rotateAnswers} onChange={value => this.onChange('rotateAnswers', value)} />
        </FormGroup>
      </React.Fragment>
    );
  }
}


TabBasket.propTypes = {
  data: PropTypes.shape({
    survey: PropTypes.shape({
      questionSettings: PropTypes.shape({
        basket: PropTypes.object.isRequired,
      }).isRequired
    }).isRequired,
  }),
  errors: PropTypes.object.isRequired,
  onChangeQuestionSettings: PropTypes.func.isRequired,
};

export default TabBasket;